import { WeatherImpactActionTypes } from './constants';

type WeatherImpactAction = { type: string, payload: {} | string };

export const weatherImpactApiResponseSuccess = (actionType: string, data: any): WeatherImpactAction => ({
    type: WeatherImpactActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const weatherImpactApiResponseError = (actionType: string, error: string): WeatherImpactAction => ({
    type: WeatherImpactActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const weatherImpactGetSummary = (query: string): WeatherImpactAction => ({
    type: WeatherImpactActionTypes.GET_SUMMARY_REQUEST,
    payload: { query },
});

export const weatherImpactGetEventMix = (query: string): WeatherImpactAction => ({
    type: WeatherImpactActionTypes.GET_EVENT_MIX_REQUEST,
    payload: { query },
});

export const weatherImpactGetCarrierPerformance = (query: string): WeatherImpactAction => ({
    type: WeatherImpactActionTypes.GET_CARRIER_PERFORMANCE_REQUEST,
    payload: { query },
});

export const weatherImpactGetShipmentReport = (query: string): WeatherImpactAction => ({
    type: WeatherImpactActionTypes.GET_SHIPMENT_REPORT_REQUEST,
    payload: { query },
});

export const weatherImpactGetWarehouseImpact = (query: string): WeatherImpactAction => ({
    type: WeatherImpactActionTypes.GET_WAREHOUSE_IMPACT_REQUEST,
    payload: { query },
});

export const weatherImpactGetEventSummary = (query: string): WeatherImpactAction => ({
    type: WeatherImpactActionTypes.GET_EVENT_SUMMARY_REQUEST,
    payload: { query },
});

export const weatherImpactGetMap = (query: string): WeatherImpactAction => ({
    type: WeatherImpactActionTypes.GET_MAP_REQUEST,
    payload: { query },
});
